import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StaticTable, {
  StaticTableColumn,
} from '../../../../components/common/table/static-table';
import css from '../index.module.css';

interface ValidationCondition {
  key?: string;
  code: string;
  name: string;
  mkCode: string;
  success: boolean;
  status?: React.ReactNode | null;
}

interface ValidationTableProps {
  data: ValidationCondition[];
  title: string;
}

const ValidationTable: React.FC<ValidationTableProps> = ({ data, title }) => {
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.crop.vaad_liz_reports_v2.validation.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    const result = data.map((row: ValidationCondition) => {
      const tableRow = { ...row };

      tableRow.status = row.success ? (
        <span className={css['success']}>{tp('success')}</span>
      ) : (
        <span className={css['failed']}>{tp('failed')}</span>
      );

      return tableRow;
    });

    setRows({ rows: result });
  }, [data, tp]);

  const columns: StaticTableColumn<ValidationCondition>[] = [
    { accessor: 'status', header: '', className: css['strong'] },
    { accessor: 'code', header: '', className: css['strong'] },
    { accessor: 'name', header: '' },
    { accessor: 'mkCode', header: '' },
  ];

  return (
    <div>
      <h4>{title}</h4>
      <div className={`${css['table']} ${css['list-validation-table']}`}>
        <StaticTable<ValidationCondition>
          data={rows}
          keyAccessor="key"
          columns={columns}
          fixedHeight
        />
      </div>
    </div>
  );
};

export default ValidationTable;
